export default __webpack_public_path__ + "static/media/remove.8a9c5e9b.svg";